export default "__VITE_ASSET__BZz9g$ne__"